import generalSetingApi from "api/generalSetting";
import { ApiResponse, ImageUrlData } from "models";
import { call, put, takeLatest } from "redux-saga/effects";
import { generalSettingAction } from "./generalSettingSlice";
import { PayloadAction } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import {
  GeneralSettingPayload,
  GeneralSettingSubmitForm,
  SmtpSubmitForm,
  SupportUserSubmitForm,
} from "models/generalSetting";

function* getGeneralDetail(action: PayloadAction<GeneralSettingPayload>) {
  try {
    const response: ApiResponse = yield call(generalSetingApi.getGeneralDetail);
    const data: ApiResponse = response.data;
    if (data.success) {
      yield put(generalSettingAction.getGeneralDetailSuccess(data));
    }
  } catch (error: any) {
    const errorData = error?.response?.data || { message: error.message || "An error occurred" };
    yield put(generalSettingAction.getGeneralDetailFailed(errorData));
  }
}

function* getSMTPDetail(action: PayloadAction<GeneralSettingPayload>) {
  try {
    const response: ApiResponse = yield call(generalSetingApi.getSMTPDetail);
    const data: ApiResponse = response.data;
    if (data.success) {
      yield put(generalSettingAction.getSMTPDetailSuccess(data));
    }
  } catch (error: any) {
    const errorData = error?.response?.data || { message: error.message || "An error occurred" };
    yield put(generalSettingAction.getSMTPDetailFailed(errorData));
  }
}

function* getSupportUserDetail(action: PayloadAction<GeneralSettingPayload>) {
  try {
    const response: ApiResponse = yield call(
      generalSetingApi.getSupportUserDetail
    );
    const data: ApiResponse = response.data;
    if (data.success) {
      yield put(generalSettingAction.getSupportUserDetailSuccess(data));
    }
  } catch (error: any) {
    const errorData = error?.response?.data || { message: error.message || "An error occurred" };
    yield put(generalSettingAction.getSupportUserDetailFailed(errorData));
  }
}

function* addSMTPDetails(action: PayloadAction<SmtpSubmitForm>) {
  try {
    const response: ApiResponse = yield call(
      generalSetingApi.addSMTPDetails,
      action.payload
    );
    const data: ApiResponse = response.data;
    if (data.success) {
      toast.success(data.message);
      yield put(generalSettingAction.addSMTPDetailsSuccess(data));
    }
  } catch (error: any) {
    const errorData = error?.response?.data || { message: error.message || "An error occurred" };
    toast.error(errorData?.message || "Something went wrong");
    yield put(generalSettingAction.addSMTPDetailsFailed(errorData));
  }
}

function* addSupportUserDetails(action: PayloadAction<SupportUserSubmitForm>) {
  try {
    const response: ApiResponse = yield call(
      generalSetingApi.addCustomerDetails,
      action.payload
    );
    const data: ApiResponse = response.data;
    if (data.success) {
      toast.success(data.message);
      yield put(generalSettingAction.addSupportUserDetailsSuccess(data));
    }
  } catch (error: any) {
    const errorData = error?.response?.data || { message: error.message || "An error occurred" };
    toast.error(errorData?.message || "Something went wrong");
    yield put(generalSettingAction.addSupportUserDetailsFailed(errorData));
  }
}

function* addGeneralDetails(action: PayloadAction<GeneralSettingSubmitForm>) {
  try {
    const response: ApiResponse = yield call(
      generalSetingApi.addGeneralDetails,
      action.payload
    );
    const data: ApiResponse = response.data;
    if (data.success) {
      toast.success(data.message);
      yield put(generalSettingAction.addGeneralDetailsSuccess(data));
    }
  } catch (error: any) {
    const errorData = error?.response?.data || { message: error.message || "An error occurred" };
    toast.error(errorData?.message || "Something went wrong");
    yield put(generalSettingAction.addGeneralDetailsFailed(errorData));
  }
}

function* getImageUrl(action: PayloadAction<ImageUrlData>) {
  try {
    const response: ApiResponse = yield call(
      generalSetingApi.getImageUrl,
      action.payload
    );
    const data: ApiResponse = response.data;
    if (data.success) {
      toast.success(data.message);
      yield put(generalSettingAction.getImageUrlSuccess(data));
    }
  } catch (error: any) {
    const errorData = error?.response?.data || { message: error.message || "An error occurred" };
    toast.error(errorData?.message || "Something went wrong");
    yield put(generalSettingAction.getImageUrlFailed(errorData));
  }
}

export default function* generalSettingSaga() {
  yield takeLatest(
    generalSettingAction.getGeneralDetail.type,
    getGeneralDetail
  );
  yield takeLatest(generalSettingAction.getSMTPDetail.type, getSMTPDetail);
  yield takeLatest(
    generalSettingAction.getSupportUserDetail.type,
    getSupportUserDetail
  );
  yield takeLatest(
    generalSettingAction.addGeneralDetails.type,
    addGeneralDetails
  );
  yield takeLatest(generalSettingAction.addSMTPDetails.type, addSMTPDetails);
  yield takeLatest(
    generalSettingAction.addSupportUserDetails.type,
    addSupportUserDetails
  );
  yield takeLatest(generalSettingAction.getImageUrl.type, getImageUrl);
}
